import { Box, Container, Grid, Button, Typography, Paper } from "@mui/material";
import { Budget } from "../../components/dashboard/budget";
import { Sales } from "../../components/dashboard/sales";
import { TasksProgress } from "../../components/dashboard/tasks-progress";
import { TotalCustomers } from "../../components/dashboard/total-customers";
import { TotalProfit } from "../../components/dashboard/total-profit";
import { TrafficByDevice } from "../../components/dashboard/traffic-by-device";
import { DashboardLayoutCustomer } from "../../components/dashboard-layout-customer";
import { ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { theme } from "../../theme";
import { useEffect, useState } from "react";
import axios from "axios";

function Dashboard() {
    const navigate = useNavigate();
    const [data, setData] = useState();
    const [isShow, setShow] = useState(false);
    
    // State lưu thông tin user để lấy mã mời
    const [profile, setProfile] = useState(null);

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const [employee, setEmployee] = useState();
    const [users, setUsers] = useState(null);
    
    useEffect(() => {
        // Lấy dữ liệu thống kê
        axios.get(`${process.env.REACT_APP_API_URL}/statistic/getallcustomer`).then((res) => setData(res.data.data));

        // Lấy thông tin User để lấy code mời
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`).then((res) => {
            if (res.data && res.data.success) {
                setProfile(res.data.data);
            }
        });
    }, []);

    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    const [content, setContent] = useState(null);
    const [users2, setUsers2] = useState(false);
    const [nap, setNap] = useState(false);
    const [rut, setRut] = useState(false);
    const [cuoc, setCuoc] = useState(false);

    // Xử lý lấy mã mời và tạo link
    const referralCode = profile ? profile.code : "";
    const linkMobile = referralCode ? `https://m.df999.mom/register?code=${referralCode}` : "";
    const linkPC = referralCode ? `https://df999.mom?code=${referralCode}` : "";

    // Hàm copy chung
    const handleCopy = (text) => {
        if (text) {
            navigator.clipboard.writeText(text);
            alert("Đã sao chép thành công!");
        }
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayoutCustomer>
                    {
                        <Box
                            component="main"
                            sx={{
                                flexGrow: 1,
                                py: 8
                            }}>
                            <Container maxWidth={false}>
                                <Grid container spacing={3}>
                                    
                                    {/* KHU VỰC HIỂN THỊ MÃ GIỚI THIỆU VÀ LINK */}
                                    <Grid item xs={12}>
                                        <Paper sx={{ 
                                            p: 3, 
                                            display: 'flex', 
                                            flexDirection: 'column', 
                                            gap: 2, 
                                            border: "1px solid #E6E8F0", 
                                            boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                                            borderRadius: 2
                                        }}>
                                            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                                                🔗 Thông Tin Giới Thiệu
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                Gửi mã hoặc đường link này cho bạn bè để nhận hoa hồng khi họ đăng ký tham gia.
                                            </Typography>

                                            {/* Mã giới thiệu */}
                                            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                                                <Box sx={{ 
                                                    flex: 1, p: 1.5, bgcolor: '#f8fafc', borderRadius: 1,
                                                    border: '1px solid #e2e8f0', color: '#334155', fontWeight: 500,
                                                    wordBreak: 'break-all', minWidth: '250px'
                                                }}>
                                                    <strong>Mã giới thiệu:</strong> {referralCode || "Đang tải dữ liệu..."}
                                                </Box>
                                                <Button 
                                                    variant="contained" color="primary" 
                                                    onClick={() => handleCopy(referralCode)} 
                                                    disabled={!profile}
                                                    sx={{ height: '48px', px: 4, fontWeight: 'bold' }}
                                                >
                                                    SAO CHÉP MÃ
                                                </Button>
                                            </Box>

                                            {/* Link Mobile */}
                                            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                                                <Box sx={{ 
                                                    flex: 1, p: 1.5, bgcolor: '#f8fafc', borderRadius: 1,
                                                    border: '1px solid #e2e8f0', color: '#334155', fontWeight: 500,
                                                    wordBreak: 'break-all', minWidth: '250px'
                                                }}>
                                                    <strong>Link Mobile:</strong> {linkMobile || "Đang tải dữ liệu..."}
                                                </Box>
                                                <Button 
                                                    variant="contained" color="primary" 
                                                    onClick={() => handleCopy(linkMobile)} 
                                                    disabled={!profile}
                                                    sx={{ height: '48px', px: 4, fontWeight: 'bold' }}
                                                >
                                                    SAO CHÉP LINK MOBI
                                                </Button>
                                            </Box>

                                            {/* Link PC */}
                                            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                                                <Box sx={{ 
                                                    flex: 1, p: 1.5, bgcolor: '#f8fafc', borderRadius: 1,
                                                    border: '1px solid #e2e8f0', color: '#334155', fontWeight: 500,
                                                    wordBreak: 'break-all', minWidth: '250px'
                                                }}>
                                                    <strong>Link PC:</strong> {linkPC || "Đang tải dữ liệu..."}
                                                </Box>
                                                <Button 
                                                    variant="contained" color="primary" 
                                                    onClick={() => handleCopy(linkPC)} 
                                                    disabled={!profile}
                                                    sx={{ height: '48px', px: 4, fontWeight: 'bold' }}
                                                >
                                                    SAO CHÉP LINK PC
                                                </Button>
                                            </Box>

                                        </Paper>
                                    </Grid>
                                    {/* KẾT THÚC KHU VỰC MÃ GIỚI THIỆU */}

                                    <Grid item xl={3} lg={6} sm={6} xs={12}>
                                        {data && <TotalCustomers user={data.thanhvien} />}
                                    </Grid>
                                    <Grid item xl={3} lg={6} sm={6} xs={12}>
                                        {data && <Budget tongnap={data.tongnaps} />}
                                    </Grid>
                                    <Grid item xl={3} lg={6} sm={6} xs={12}>
                                        {data && <TasksProgress tongrut={data.tongruts} />}
                                    </Grid>
                                    <Grid item xl={3} lg={6} sm={6} xs={12}>
                                        {data && <TotalProfit tongcuoc={data.tongcuoc} sx={{ height: "100%" }} />}
                                    </Grid>
                                    <Grid item lg={7} md={7} xl={7} xs={12}>
                                        <Sales sx={{ border: "1px solid #E6E8F0" }} data={data} />
                                    </Grid>
                                    <Grid item lg={5} md={5} xl={5} xs={12}>
                                        <TrafficByDevice sx={{ border: "1px solid #E6E8F0", height: "100%" }} data={data} />
                                    </Grid>
                                </Grid>
                            </Container>
                        </Box>
                    }
                </DashboardLayoutCustomer>
            </ThemeProvider>
        </>
    );
}

export default Dashboard;